let initialState = {
  dataSearch: {},
  goBack: false
}

function baoCaoDinhKy(state = initialState, action) {
  let newState = {
    ...state
  };
  switch (action.type) {
    case 'BCDK_UPDATE_DATA_SEARCH':
      newState.dataSearch = action.dataSearch;
      return newState;
    case 'BCDK_GO_BACK':
      newState.goBack = true;
      return newState;
    case 'BCDK_RESET_GO_BACK':
      newState.goBack = false;
      return newState;
    default:
      return newState;
  }
}

export { baoCaoDinhKy }



// WEBPACK FOOTER //
// ./src/reducers/baoCaoDinhKy.js